import {CALL_API} from '../../middleware/api';

// 假期管理
export const ADJUST_LIST_REQUEST = 'ADJUST_LIST_REQUEST'
export const ADJUST_LIST_SUCCESS = 'ADJUST_LIST_SUCCESS'
export const ADJUST_LIST_FAILURE = 'ADJUST_LIST_FAILURE'

// page=1
export function getAdjustList(params) {
	return {
		[CALL_API]: {
			types: [ADJUST_LIST_REQUEST, ADJUST_LIST_SUCCESS, ADJUST_LIST_FAILURE],
			endpoint: 'workflow/leave/adjust-list',
      methods: 'POST',
      params
		}
	}
}

export default (params) => {
	return (dispatch, getState) => {
		return dispatch(getAdjustList(params));
	};
};


// WEBPACK FOOTER //
// ./src/action/leave/adjustList.js